import { initialState } from "./slice";
import { createSelector } from "reselect";

export const selectPdf = (state) => state.pdf || initialState;

export const selectPage = createSelector(
  selectPdf,
  (pdfState) => pdfState.page
);

export const selectTotalPages = createSelector(
  selectPdf,
  (pdfState) => pdfState.totalPages
);

export const selectScale = createSelector(
  selectPdf,
  (pdfState) => pdfState.scale
);

export const selectCanvasMarginLeft = createSelector(
  selectPdf,
  (pdfState) => pdfState.canvas.canvasMarginLeft
);

export const selectIsCustomFile = createSelector(
  selectPdf,
  (pdfState) => pdfState.isCustomFile
);

export const selectCanvas = createSelector(
  selectPdf,
  (pdfState) => pdfState.canvas
);

export const selectCanvasWidth = createSelector(
  selectPdf,
  (pdfState) => pdfState.canvas.canvasWidth
);

export const selectCanvasHeight = createSelector(
  selectPdf,
  (pdfState) => pdfState.canvas.canvasHeight
);

export const selectCurrentPageOriginalHeight = createSelector(
  selectPdf,
  (pdfState) => pdfState.currentPageOriginal.currentPageOriginalHeight
);

export const selectCurrentPageOriginalWidth = createSelector(
  selectPdf,
  (pdfState) => pdfState.currentPageOriginal.currentPageOriginalWidth
);

export const selectCurrentPageOriginalRotationAngle = createSelector(
  selectPdf,
  (pdfState) => pdfState.currentPageOriginal.currentPageOriginalRotationAngle
);

export const selectFile = createSelector(
  selectPdf,
  (pdfState) => pdfState.fileData.file
);

export const selectFileName = createSelector(
  selectPdf,
  (pdfState) => pdfState.fileData.pdfFileName
);

export const selectUrl = createSelector(
  selectPdf,
  (pdfState) => pdfState.fileData.url
);

export const selectConvertingToPdf = createSelector(
  selectPdf,
  (pdfState) => pdfState.convertingToPdf
);






